<template>
    <div class="p-relative">

        <Toolbar :is-list="true" v-on:toolbar-button-click="onToolbarClick">
            <SearchPanel v-model="search" :has-filter="false" />
        </Toolbar>

        <v-data-table
            :loading="loading"
            :headers="headers"
            :items="entities"
            :options.sync="options"
            :server-items-length="total"
            :items-per-page="10"
            :footer-props="{ itemsPerPageOptions:[5, 10, 20] }"
            :page.sync="options.page"
            @page-count="paginationPageCount = $event"
            @dblclick:row="(event, data) => onRowDblClick(data.item.id)"
            class="elevation-1 customization-list-table pagination-list-table sticky-table"
        >

            <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

                <template v-slot:[`item.key`]="{ item }">
                <div class="elipsis-text-wrap">
                    <div class="etw-text-container">
                        <div class="etw-text" v-tooltip.top-center="item.key">
                            {{ item.key }}
                        </div>
                    </div>
                </div>
            </template>

            <template v-slot:[`item.name`]="{ item }">
                <div class="elipsis-text-wrap">
                    <div class="etw-text-container">
                        <div class="etw-text" v-tooltip.top-center="item.name">
                            {{ item.name }}
                        </div>
                    </div>
                </div>
            </template>

            <template v-slot:[`item.requisite_group`]="{ item }">
                <div class="elipsis-text-wrap">
                    <div class="etw-text-container">
                        <div class="etw-text" v-tooltip.top-center="item.requisite_group">
                            {{ item.requisite_group }}
                        </div>
                    </div>
                </div>
            </template>

            <template v-slot:[`item.requisite_type`]="{ item }">
                <div class="elipsis-text-wrap">
                    <div class="etw-text-container">
                        <div class="etw-text">
                            {{ $t(getRequisiteTypeName(item.requisite_type)) }}
                        </div>
                    </div>
                </div>
            </template>

            <template v-slot:[`footer.prepend`]>
                <v-pagination
                    v-model="options.page"
                    :length="paginationPageCount"
                    :total-visible="$listPaginationTotal"
                    color="teal"
                ></v-pagination>
            </template>

        </v-data-table>

        <CreateRequisiteDlg ref="CreateRequisiteDlgRef" />

    </div>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from 'vuex';
import { httpAPI } from "@/api/httpAPI";
import sys from "@/services/system";

import Toolbar from '@/components/documents/Toolbar.vue';
import SearchPanel from '@/components/documents/SearchPanel.vue';
import CreateRequisiteDlg from '@/views/global/configuration/dialogs/CreateRequisiteDlg.vue';

export default {
    columnIndex:  {
        'requisite_group': 2,
        'name': 3,
        'key': 4
    },
    name: 'Requisites',
    components: {
        Toolbar,
        SearchPanel,
        CreateRequisiteDlg
    },
    computed: {
        ...mapGetters('global/configuration/requisites', { requisiteTypes: 'getRequisiteTypes' }),
        collection() {
            return 'Requisites';
        },
        headers() {
            return [
                { text: this.$t("Ключ"), value: 'key', width: '100px' },
                { text: this.$t("Наименование"), value: 'name' },
                { text: this.$t("Группа"), value: 'requisite_group', width: '300px' },
                { text: this.$t("Тип"), value: 'requisite_type', width: '100px', sortable: false}
            ];
        },
        search: {
            get: function() {
                let op = this.$store.getters['global/configuration/requisites/getSearch'];
                return op;
            },
            set: _.debounce(function(v) {
                this.resetPage();
                this.$store.commit('global/configuration/requisites/SET_SEARCH', v);
            }, 500)
        },
        options: {
            get: function() {
                let op = this.$store.getters['global/configuration/requisites/getTableOptions'];
                return op;
            },
            set: function(newValue) {
                this.$store.commit('global/configuration/requisites/SET_TABLE_OPTION', newValue);
            }
        },
        filter () {
            return {
                ...this.options,
                SearchStr: this.search
            }
        }
    },
    data: () => ({
        loading: true,
        total: 0,
        entities: [],
        prevTableFilterObject: null,
        paginationPageCount: 0
    }),
    methods: {
        ...mapActions(['setOverlayVisible']),
        dateFormat: sys.dateFormat,
        resetPage() {
            this.$store.commit('global/configuration/requisites/SET_TABLE_OPTION_PAGE', 1);
        },
        async onToolbarClick(event, button) {
            if (!button.Action)
                return;

            let action = this[button.Action];

            if (action)
                action(button);
        },
        async Refresh() {
            await this.getData(true);
        },
        async getData(isRefresh = false) {
            let filterJson = this.getSerializedFilter();
            let newFilterObj = JSON.parse(filterJson);

            if (isRefresh === false && this.$_.isEqual(this.prevTableFilterObject, newFilterObj))
                return;

            this.prevTableFilterObject = newFilterObj;
            this.total = 0;
            this.entities = [];
            this.loading = true;

            let response = await httpAPI({
                url: `api/document-templates/list?collection=${this.collection}&filter=${filterJson}`,
                method: 'GET',
                headers: { "isCommon": true }
            });

            this.entities = response?.data?.Payload?.data ?? [];
            this.total = response?.data?.Payload?.total ?? 0;
            this.loading = false;
        },
        getSerializedFilter() {
            let { sortBy, sortDesc, page, itemsPerPage, SearchStr } = this.filter;

            let OrderDir = sortDesc.length <= 0 ? false : sortDesc[0];
            let sortColumn = sortBy.length <= 0 ? "name" : sortBy[0];
            let OrderBy = this.$options.columnIndex[sortColumn] ?? 3;

            return JSON.stringify({ 
                SearchStr,
                OrderBy,
                OrderDir,
                Limit: itemsPerPage,
                Offset: (page - 1) * itemsPerPage
            });
        },
        getRequisiteTypeName(requisiteTypeId) {
            let type = this.requisiteTypes.find(x => x.id == requisiteTypeId);
            return type?.value ?? "Не_указано";
        },
        async onRowDblClick(itemId) {
            let response = await httpAPI({
                url: `api/actions/open?type=Documents.Requisite&id=${itemId}`,
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'isCommon': true }
            });

            if (response)
                await this.$refs.CreateRequisiteDlgRef.open({ requisite: JSON.parse(JSON.stringify(response.data.Payload.Data.Object)), allowEdit: false });
        }
    },
    watch: {
        filter: {
            handler () {
                this.getData()
            },
            deep: true,
        },
    },
    created() {
        let fakeMenu =
        [
            { Action: "Refresh", Icon: "refresh", Items: null, Text: this.$t("Обновить"), ToolTip: this.$t("Обновить_форму"), Type: null }
        ];

        this.$store.commit('documents/toolbar/SET_MENU', { menu: fakeMenu });
    }
}
</script>